import getApplicationVariant, {
  APPLICATION_VARIANTS
} from 'utils/getApplicationVariant';

let _isDineInVariant = null;
export default (useCache = true) => {
  if (useCache && _isDineInVariant !== null) {
    return _isDineInVariant;
  }

  _isDineInVariant = getApplicationVariant() === APPLICATION_VARIANTS.DINE_IN;
  return _isDineInVariant;
};
